import { memo, FC, SVGProps } from "react"

export const PlusIcon: FC<SVGProps<SVGSVGElement>> = memo((props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6.99902 1.16602V12.8327" />
    <path d="M1.16602 6.99902H12.8327" />
  </svg>
))
export default PlusIcon
